import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-empty-state-placeholder',
  templateUrl: './empty-state-placeholder.component.html',
  styleUrls: ['./empty-state-placeholder.component.css']
})
export class EmptyStatePlaceholderComponent implements OnInit {

  @Input() title!: string;
  @Input() subtitle!: string;
  @Input() icon!: string;

  constructor() { }

  ngOnInit(): void {
  }

}
